import axios from "axios";

const api = axios.create({
    baseURL: "https://stage.myskool.club/myskoolcollabapibackend/api/",
});

export default api;
